module.exports = __webpack_public_path__ + "img/info-bg.ce1e2cbb.png";